import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ left, center, right }) => (
  <div className="header">
    <div className="header-left">{left()}</div>
    <div className="header-center">{center()}</div>
    <div className="header-right">{right()}</div>
  </div>
);

Header.propTypes = {
  left: PropTypes.func,
  center: PropTypes.func,
  right: PropTypes.func
};

Header.defaultProps = {
  left: () => {},
  center: () => {},
  right: () => {}
};

export default Header;
